import React, { FC } from "react"

import { Button, Modal } from "@/components"

import "./style.less"

interface InsufficientBalanceModalProps {
  visible: boolean
  tryAgain: () => void
  switchAddress: () => void
  canSwitch?: boolean
  onClose?: () => void
}

const InsufficientBalanceModal: FC<InsufficientBalanceModalProps> = ({
  visible,
  canSwitch,
  tryAgain,
  switchAddress,
  onClose,
}) => {
  return (
    <Modal
      visible={visible}
      mask={false}
      onClose={onClose}
      wrapperClassName="modal-wrapper"
    >
      <React.Fragment>
        <div className="insufficient-title">insufficient balance</div>
        <img className="insufficient-image" src={require("@/assets/info.png")} />
        <Button className="insufficient-btn" onClick={tryAgain}>Try again</Button>
        {canSwitch && (
          <Button
            className="insufficient-btn insufficient-lastBtn"
            type="primary"
            onClick={switchAddress}
          >
            Switch Address

          </Button>
        )}
      </React.Fragment>
    </Modal>
  )
}

export default InsufficientBalanceModal
